import React, { useEffect } from "react";
import ComptePage from "../components/compte/ComptePage";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
function Compte(acces) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} />
      <ComptePage />
    </>
  );
}

export default Compte;
